import { headerAndFooter as config } from '@config';
import headerAndFooter from 'src/views/header-and-footer';

function createTemporaryLayer (canvas, layerName, className) {
  let layer = document.querySelector(`#svgcontent > g.${className}`);

  if (!layer) {
    layer = canvas.createLayer(layerName, { className });
  }

  return layer;
}

function handleCreateLayers (canvas, layers, callback) {
  layers.forEach(({ layer: layerName, id, class: className }) => {
    const target = document.getElementById(id);
    const elements = target.querySelectorAll('.element');
    const temporaryLayer = createTemporaryLayer(canvas, layerName, className);

    handleAppendElementsToLayer(temporaryLayer, elements);
  });

  if (callback) callback();
}

function removeLayer (canvas, layerName) {
  canvas.setCurrentLayer(layerName);

  if (canvas.getCurrentLayerName() !== layerName) {
    return;
  }

  canvas.deleteCurrentLayer();
  canvas.clearSelection();
}

function handleDeleteLayers (canvas, layers, callback) {
  layers.forEach(({ layer: layerName, id, selector, class: className }) => {
    const target = document.getElementById(id);

    if (!target) return;

    const elements = document.querySelectorAll(`#svgcontent > g.${className} .element`);

    handleAppendElementsToLayer(target, elements, () => {
      removeLayer(canvas, layerName);
    });
  });

  if (callback) callback();
}

function handleAppendElementsToLayer (target, elements = [], callback) {
  if (elements?.length) {
    elements.forEach(element => {
      target.appendChild(element);
    });
  }

  if (callback) callback();
}

function handleSelectedLayer (canvas, layer) {
  document.addEventListener('click', (data) => {
    const target = data.target.closest('#svg_footer,#svg_header');
    const isHeaderAndFooter = [config.header.id, config.footer.id].includes(target?.id);

    if (!target || !isHeaderAndFooter) return;

    const targetLayer = target.id === config.header.id ? config.header.layer : config.footer.layer;

    canvas.setCurrentLayer(targetLayer);
    INKIVE.Menus.elementPopupMenu.hide();
  }, true);
}

function mainLayoutElement () {
  return document.querySelector(`#svgcontent > g.${config.main.class}`);
}

function setMainLayer (canvas) {
  const [layerName] = canvas.getCurrentDrawing().all_layers.find(([, element]) => {
    return element.classList.contains('main');
  });

  canvas.setCurrentLayer(layerName);
}

export default function extensionHeaderAndFooter ({ svgroot, canvas }) {
  const sidebarMenuItems = document.querySelectorAll('#tool-panel .tool-cta-container li:not(.hide) > a[tag]');

  return {
    saveHeaderAndFooterState () {
      const targets = [config.header, config.footer];

      targets.forEach(({ layer: layerName, selector, class: className }) => {
        const target = document.querySelector(selector);
        const elements = document.querySelector(`.${className}`)?.querySelectorAll('.element');
        const temporaryLayer = createTemporaryLayer(canvas, layerName, className);

        if (!target || !elements?.length) return;

        handleAppendElementsToLayer(target, elements, () => {
          canvas.setCurrentLayer(config.main.layer);
        });
      });
    },

    showHeaderAndFooter () {
      if (!mainLayoutElement()) return;

      handleCreateLayers(canvas, [config.header, config.footer], () => {
        canvas.setCurrentLayer(config.main.layer);
        this.toggleHeaderAndFooter(true);
        this.showHeaderAndFooterMenu();
        handleSelectedLayer(canvas);
        headerAndFooter.mountApp();
      });
    },

    showHeaderAndFooterMenu () {
      const element = mainLayoutElement();
      if (!element) return;

      canvas.clearSelection();

      INKIVE.Menus.elementPopupMenu.render([element], 'headerAndFooter');
      INKIVE.EditorFacade.handle('header_and_footer', 'edit');
    },

    hideHeaderAndFooter () {
      if (!mainLayoutElement()) return;

      handleDeleteLayers(canvas, [config.footer, config.header], () => {
        this.toggleHeaderAndFooter(false);
        headerAndFooter.closeApp();
        setMainLayer(canvas);
      });
    },

    showHeaderView () {
      const header = document.getElementById(config.header.id);
      if (!header) return;

      canvas.setCurrentLayer(config.header.layer);

      INKIVE.Menus.elementPopupMenu.hide();
    },

    showFooterView () {
      const footer = document.getElementById(config.footer.id);
      if (!footer) return;

      canvas.setCurrentLayer(config.footer.layer);

      INKIVE.Menus.elementPopupMenu.hide();
    },

    toggleHeaderAndFooter (isEnabled) {
      svgroot.classList.toggle('header-and-footer-active', isEnabled);

      [...sidebarMenuItems]
        .filter(item => !config.allowedMenuItems.includes(item.getAttribute('tag').toLowerCase()))
        .forEach(element => element.parentNode.classList.toggle('hide', isEnabled));

      const sidebarHeadings = document.querySelector('.tool-panel-inner .tool-content #tabText .sidebar-headings');
      sidebarHeadings?.classList.toggle('hidden', isEnabled);
    }
  };
}
